import style from './P2PPhoneNumberInput.css';
import ClearIcon from '../../shared/Icons/ClearIcon';
import { _className } from '../../../utils/classname.utils';

export default function P2PPhoneNumberInput({
  className = '',
  countryCode,
  value,
  onChange,
  onClear,
  disabled,
  hasError,
  errorMessage,
}) {
  function onValueChange(event) {
    const filteredNumber = event.target.value.replace(/[^0-9]/g, '');

    const formattedNumber = filteredNumber
      .replace(/^(.{0,4})(.{0,3})(.{0,4})/g, '$1 $2 $3')
      .trim();

    return onChange(formattedNumber);
  }

  return (
    <div className={`${className} ${style.container} `}>
      <input
        className={`${style.input} ${style.countryCode}`}
        value={`+${countryCode}`}
        disabled
      />
      <div className={style.content}>
        <div className={style.number}>
          <input
            disabled={disabled}
            className={`${style.input} ${
              hasError ? style['input--error'] : ''
            }`}
            value={value}
            onChange={onValueChange}
            maxLength={13}
          />
          {value && (
            <ClearIcon
              onClick={onClear}
              className={`${style.icon} ${style['icon--clear']} ${_className(
                disabled,
                style['icon--disabled'],
              )}`}
            />
          )}
        </div>
        {hasError && errorMessage && (
          <span className={style.error}>{errorMessage}</span>
        )}
      </div>
    </div>
  );
}
